import React, { FC } from "react";
import LocationInput from "../LocationInput";
// import PriceRangeInput from "./PriceRangeInput";
// import PropertyTypeSelect from "./PropertyTypeSelect";

export interface RealEstateSearchFormProps {}

const RealEstateSearchForm2: FC<RealEstateSearchFormProps> = () => {
  const renderForm = () => {
    return (
      <div className="w-full  mt-8  h-[130px] rounded-3xl  shadow-xl  bg-white">
        <LocationInput className="" />

        {/* <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <PropertyTypeSelect /> */}
        {/* <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <PriceRangeInput /> */}
      </div>
    );
  };

  return renderForm();
};

export default RealEstateSearchForm2;